var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.childList),function(child,childIndex){return _c('div',{key:childIndex},[_c('p',{domProps:{"innerHTML":_vm._s(child)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }